/**
 * Aceleres: cor do autor numa mensagem citada.
 *
 * Espelha o palette do <Avatar /> (text colors do tuple light), indexado por
 * `name.length % 6` — mesma lógica de `getColorsByNameLength`. Assim a barra
 * lateral e o nome no card de resposta combinam com o tom do avatar de quem
 * está sendo citado.
 *
 * Vive aqui porque duas telas fazem a mesma pergunta: a citação dentro do
 * balão (components-next/message/bubbles/Base.vue) e o card de resposta do
 * compositor (ReplyToMessage.vue). Sem isto, o mesmo contato apareceria com
 * cores diferentes nos dois lugares.
 */
export const QUOTED_ACCENT_COLORS = [
  '#C2298A',
  '#99543A',
  '#60646C',
  '#008573',
  '#4747C2',
  '#3A5BC7',
];

const NEUTRAL_ACCENT_INDEX = 2;

export const quotedAccentColor = name => {
  if (!name) return QUOTED_ACCENT_COLORS[NEUTRAL_ACCENT_INDEX];
  return QUOTED_ACCENT_COLORS[name.length % QUOTED_ACCENT_COLORS.length];
};
